import { ICompany, ICompanyMember } from '../common/models/Company'
import {
  CompanyFilterValues,
  ICompanyFilterScope,
  IUseCompanyFiltersResult,
  useCompanyFilters,
} from './useCompanyFilters'
import {
  memberPassesCulturalPhaseFilter,
  memberPassesJobFilter,
  memberPassesTeamFilter,
} from '../utils/companyFilterMatchers'

export interface IUseMemberFiltersOptions {
  team?: boolean
  job?: boolean
  culturalPhase?: boolean
  initial?: {
    team?: string[]
    job?: string[]
    culturalPhase?: string[]
  }
  scope?: ICompanyFilterScope
}

export type IUseMemberFiltersResult = IUseCompanyFiltersResult<ICompanyMember>

const matchMember = (
  member: ICompanyMember,
  values: CompanyFilterValues
): boolean =>
  memberPassesTeamFilter(values.team, member) &&
  memberPassesJobFilter(values.job, member) &&
  memberPassesCulturalPhaseFilter(values.culturalPhase, member)

export const useMemberFilters = (
  company: ICompany | undefined,
  options: IUseMemberFiltersOptions = {
    team: true,
    job: true,
    culturalPhase: true,
  }
): IUseMemberFiltersResult =>
  useCompanyFilters<ICompanyMember>(company, {
    team: options.team !== false,
    job: options.job !== false,
    culturalPhase: options.culturalPhase !== false,
    initial: options.initial,
    scope: options.scope,
    matches: matchMember,
  })
